<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="scheduleForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1">Step</label>
        </div>
        <div class="input-group col-8">
          <input class="form-control rb-input" placeholder="Please enter step." formControlName="step" type="text" />
          <div class="col-12 error-mssg" *ngIf="(formControl.step.touched || submitted) && formControl.step.errors">
            <label class="text-danger" *ngIf="formControl.step.errors.required">*Step is required.</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1" translate> Start Date</label>
        </div>
        <div class="input-group col-8">
          <p-calendar
            [minDate]="today"
            class="w-100-p"
            formControlName="startDate"
            placeholder="Start date"
          ></p-calendar>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.startDate.touched || submitted) && formControl.startDate.errors"
          >
            <label for="startDate" class="text-danger" *ngIf="formControl.startDate.errors.required">
              *Please select start date.
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1" translate> End Date</label>
        </div>
        <div class="input-group col-8">
          <p-calendar [minDate]="today" class="w-100-p" formControlName="endDate" placeholder="End date"></p-calendar>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.endDate.touched || submitted) && formControl.endDate.errors"
          >
            <label for="endDate" class="text-danger" *ngIf="formControl.endDate.errors.required">
              *Please select start date.
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1" translate> User Groups</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="userGroups"
            optionLabel="name"
            optionValue="uuid"
            formControlName="userGroupId"
            placeholder="Select User group"
          ></p-dropdown>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.userGroupId.touched || submitted) && formControl.userGroupId.errors"
          >
            <label class="text-danger" *ngIf="formControl.userGroupId.errors.required">
              *Please select User Group.
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <!-- <div class="col-12">
          <label for="options" class="text-black-1">Options</label>
        </div> -->
        <div class="input-group" formArrayName="options">
          <div class="mt-2 wd-100" *ngFor="let opt of optionsData.controls; let idx = index">
            <div class="row" [formGroupName]="idx">
              <div class="col d-flex-col">
                <label for="options-instrumentName" class="text-black-1">Instrument Name</label>
                <p-dropdown
                  class="w-100-p"
                  [options]="surveyDataTable"
                  optionLabel="name"
                  formControlName="instrumentName"
                  placeholder="Select Instrument Name"
                ></p-dropdown>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('instrumentName').touched || submitted) && opt.get('instrumentName').errors"
                >
                  <label
                    for="options-instrumentName"
                    class="text-danger"
                    *ngIf="opt.get('instrumentName').errors.required"
                    >*Option Instrument Name is required.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="options-startDate" class="text-black-1">Start Date</label>
                <p-calendar
                  id="options-startDate"
                  class="w-100-p"
                  formControlName="startDate"
                  placeholder="Start date"
                  [minDate]="formControl?.startDate?.value"
                  [maxDate]="formControl?.endDate?.value"
                >
                </p-calendar>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('startDate').touched || submitted) && opt.get('startDate').errors"
                >
                  <label for="options-startDate" class="text-danger" *ngIf="opt.get('startDate').errors.required"
                    >*Start date is required.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="options-endDate" class="text-black-1">End Date</label>
                <p-calendar
                  id="options-endDate"
                  class="w-100-p"
                  formControlName="endDate"
                  placeholder="End date"
                  [minDate]="opt.get('startDate').value"
                  [maxDate]="formControl?.endDate?.value"
                >
                </p-calendar>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('endDate').touched || submitted) && opt.get('endDate').errors"
                >
                  <label for="options-endDate" class="text-danger" *ngIf="opt.get('endDate').errors.required"
                    >*End date is required.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="options-userReminders" class="text-black-1">User Reminders</label>
                <p-calendar
                  class="w-100-p"
                  selectionMode="multiple"
                  formControlName="userReminders"
                  placeholder="User Reminders"
                  [minDate]="formControl?.startDate?.value"
                  [maxDate]="opt.get('endDate')?.value"
                >
                </p-calendar>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('userReminders').touched || submitted) && opt.get('userReminders').errors"
                >
                  <label
                    for="options-userReminders"
                    class="text-danger"
                    *ngIf="opt.get('userReminders').errors.required"
                    >*User Reminders is required.</label
                  >
                </div>
              </div>
              <div class="col-1 delete-box">
                <img (click)="removeOption(idx)" src="../../../../assets/images/core/delete.png" />
              </div>
            </div>
          </div>
          <button *ngIf="!formControl?.startDate?.errors" class="btn-save mt-3" (click)="addNewOption()">
            + Instrument
          </button>
        </div>

        <div class="input-group" formArrayName="wearableOptions">
          <div class="mt-2 wd-100" *ngFor="let opt of wearableOptionsData.controls; let idx = index">
            <div class="row" [formGroupName]="idx">
              <div class="col-2 d-flex-col">
                <label for="wearableOptions-wearableName" class="text-black-1"> Wearable</label>
                <p-dropdown
                  class="w-100-p"
                  [options]="wearables"
                  formControlName="wearableName"
                  placeholder="Choose Wearable"
                ></p-dropdown>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('wearableName').touched || submitted) && opt.get('wearableName').errors"
                >
                  <label
                    for="wearableOptions-wearableName"
                    class="text-danger"
                    *ngIf="opt.get('wearableName').errors.required"
                    >*Option Wearable is required.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="wearableOptions-startDate" class="text-black-1">Start Date</label>
                <p-calendar
                  id="wearableOptions-startDate"
                  class="w-100-p"
                  formControlName="startDate"
                  placeholder="Start date"
                  [minDate]="formControl?.startDate?.value"
                  [maxDate]="formControl?.endDate?.value"
                >
                </p-calendar>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('startDate').touched || submitted) && opt.get('startDate').errors"
                >
                  <label
                    for="wearableOptions-startDate"
                    class="text-danger"
                    *ngIf="opt.get('startDate').errors.required"
                    >*Start date is required.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="wearableOptions-endDate" class="text-black-1">End Date</label>
                <p-calendar
                  id="wearableOptions-endDate"
                  class="w-100-p"
                  formControlName="endDate"
                  placeholder="End date"
                  [minDate]="opt.get('startDate').value"
                  [maxDate]="formControl?.endDate?.value"
                >
                </p-calendar>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('endDate').touched || submitted) && opt.get('endDate').errors"
                >
                  <label for="wearableOptions-endDate" class="text-danger" *ngIf="opt.get('endDate').errors.required"
                    >*End date is required.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="wearableOptions-minDays" class="text-black-1"> Min. Days </label>
                <input
                  id="wearableOptions-minDays"
                  class="form-control rb-input"
                  placeholder="Min. days of Wearable data"
                  formControlName="minDays"
                  name="minDays"
                  type="text"
                />
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('minDays').touched || submitted) && opt.get('minDays').errors"
                >
                  <label for="wearableOptions-minDays" class="text-danger" *ngIf="opt.get('minDays').errors.required"
                    >*Option This is a required field.</label
                  >
                </div>
              </div>
              <div class="col-2 d-flex-col">
                <label for="wearableOptions-isOptional" class="text-black-1"> Optional? </label>
                <p-dropdown
                  class="w-100-p"
                  [options]="mandatoryOptions"
                  formControlName="isOptional"
                  placeholder="Optional / Mandatory ? "
                ></p-dropdown>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('isOptional').touched || submitted) && opt.get('isOptional').errors"
                >
                  <label
                    for="wearableOptions-isOptional"
                    class="text-danger"
                    *ngIf="opt.get('isOptional').errors.required"
                    >*Option This is a required field.</label
                  >
                </div>
              </div>

              <div class="col-1 delete-box">
                <img (click)="removeWearableOption(idx)" src="../../../../assets/images/core/delete.png" />
              </div>
            </div>
          </div>
          <button *ngIf="!formControl?.startDate?.errors" class="btn-save mt-3" (click)="addWearable()">
            + Wearables
          </button>
        </div>
        <!--        <div class="row mt-3 col-12" *ngIf="!formControl?.startDate?.errors">-->
        <!--          <div class="col-4">-->
        <!--            <label class="text-black-1">Select Reminder Email template</label>-->
        <!--          </div>-->
        <!--          <div class="col-4">-->
        <!--            <p-dropdown-->
        <!--              class="w-100-p"-->
        <!--              [options]="emailTemplate"-->
        <!--              optionLabel="templateName"-->
        <!--              optionValue="uuid"-->
        <!--              formControlName="reminderEmailTemplateId"-->
        <!--              placeholder="Select Reminder Email Template"-->
        <!--            ></p-dropdown>-->
        <!--            <div-->
        <!--              class="col-12 error-mssg"-->
        <!--              *ngIf="-->
        <!--                (formControl.reminderEmailTemplateId.touched || submitted) && formControl.reminderEmailTemplateId.errors-->
        <!--              "-->
        <!--            >-->
        <!--              <label class="text-danger" *ngIf="formControl.reminderEmailTemplateId.errors.required">-->
        <!--                *Please select reminder Email Template.-->
        <!--              </label>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="wd-100 mt-3" *ngIf="!formControl?.startDate?.errors">
          <div class="row">
            <div class="col-4">
              <div class="ui checkbox">
                <input
                  class="form-control"
                  formControlName="isNotify"
                  (change)="toggleEmailTemplates($event.target.checked)"
                  type="checkbox"
                  name="isNotify"
                />
                <label>Notify Participants?</label>
              </div>
            </div>
            <div *ngIf="showEmailTemplates" class="col-4">
              <p-dropdown
                class="w-100-p"
                [options]="emailTemplate"
                optionLabel="templateName"
                optionValue="uuid"
                formControlName="emailTemplateId"
                placeholder="Select Email Template"
              ></p-dropdown>
              <div
                class="col-12 error-mssg"
                *ngIf="(formControl.emailTemplateId.touched || submitted) && formControl.emailTemplateId.errors"
              >
                <label class="text-danger" *ngIf="formControl.emailTemplateId.errors.required">
                  *Please select Email Template.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Schedule</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
